import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import AnalyticsIcon from '../../../../assets/images/svg/AnalyticsIcon';
import DashboardIcon from '../../../../assets/images/svg/DashboardIcon';
import JobsIcon from '../../../../assets/images/svg/JobsIcon';
import MembersIcon from '../../../../assets/images/svg/MembersIcon';
import MultiMembersIcon from '../../../../assets/images/svg/MultiMembersIcon';
import { useAuth } from '../../../../context/AuthProvider';
import { classNames } from '../../../utils';
import NavigationLink from './NavigationLink';
import UserSettings from './UserSettings';
import icon from '../../../../assets/images/ckit_logo.png';
import ProfileIcon from '../../topNav/components/ProfileIcon';
import SupportIcon from '../../../../assets/images/svg/SupportIcon';

const AdminSideNav: FC = () => {
  const { isAuthenticated, isAdministrator } = useAuth();
  const destinations = [
    {
      dest: '/administrator/dashboard',
      label: 'Dashboard',
      icon: (
        <DashboardIcon className='stroke-current' width='16px' height='16px' />
      ),
    },
    {
      dest: '/administrator/community',
      label: 'Communities',
      icon: <JobsIcon className='stroke-current' width='16px' height='16px' />,
    },
    {
      dest: '/administrator/admin-members',
      label: 'Admin',
      icon: (
        <MembersIcon className='stroke-current' width='16px' height='16px' />
      ),
    },
    {
      dest: '/administrator/users',
      label: 'Users',
      icon: (
        <MultiMembersIcon
          className='fill-current stroke-current'
          width='16px'
          height='16px'
        />
      ),
    },
    {
      dest: '/administrator/analytics',
      label: 'Analytics',
      icon: (
        <AnalyticsIcon className='stroke-current' width='16px' height='16px' />
      ),
    },
    {
      dest: '/administrator/support',
      label: 'Support',
      icon: (
        <SupportIcon
          className='stroke-current'
          strokeWidth={4}
          width='16px'
          height='16px'
        />
      ),
    },
  ];
  const navigate = useNavigate();

  const handleNavigateHome = (): string => {
    if (isAuthenticated && isAdministrator) {
      return '/administrator/dashboard';
    }

    if (isAuthenticated && !isAdministrator) {
      return '/admin/dashboard';
    }

    return '/';
  };

  return (
    <div
      className={classNames(
        'fixed bottom-0 top-0 z-20 flex w-12 flex-col bg-gray-darkest shadow-md',
      )}
    >
      <button
        className='cursor-pointer outline-none focus:outline-none'
        onClick={() => navigate(handleNavigateHome())}
      >
        <div className='flex h-16 items-center justify-center'>
          <ProfileIcon imgSrc={icon as string} width='w-7' height='h-7' />
        </div>
      </button>

      <ul className='flex w-full flex-1 flex-col'>
        {destinations.map((dest, idx) => (
          <NavigationLink key={idx} {...dest} />
        ))}
      </ul>

      <UserSettings />
    </div>
  );
};

export default AdminSideNav;
